var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTblarrrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46055 0.320204C3.75848 0.0265659 4.24152 0.026566 4.53945 0.320205L7.27503 3.01639C7.75562 3.49006 7.41524 4.29998 6.73558 4.29998H1.26442C0.584758 4.29998 0.244379 3.49006 0.724976 3.01639L3.46055 0.320204Z",
    fill: "#CBD5E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46055 9.67975C3.75848 9.97338 4.24152 9.97338 4.53945 9.67975L7.27503 6.98356C7.75562 6.50989 7.41524 5.69998 6.73558 5.69998H1.26442C0.584758 5.69998 0.244379 6.50989 0.724976 6.98356L3.46055 9.67975Z",
    fill: "#CBD5E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTblarrrow);
export default __webpack_public_path__ + "static/media/tblarrrow.657c235b4f8bd93cbabe6f2983e1b4c2.svg";
export { ForwardRef as ReactComponent };